import { useParams } from "react-router-dom";
import { TicketQrDisplay } from "../../containers/Ticket/TicketQrDisplay";

function TicketPage() {
  const { token } = useParams();
  return <TicketQrDisplay token={token} />;
}

export { TicketPage };
